import axios from 'axios';
import env from '@medflex/utils/config';
import Logger from '@medflex/utils/Logger';

axios.defaults.baseURL = env.INSTANT_MESSAGE_SERVICE_ENDPOINT;

const DEBUG = env.DEBUG === '1';
let REQUEST_ID = 0;
let G = () => null;
let GE = () => null;
let L = () => null;
let LN = () => null;

if (DEBUG) {
  const debugName = '[apiClient]';
  G = name => Logger.gc(`${debugName} ${name}`);
  GE = name => Logger.ge(`${debugName} ${name}`);
  LN = (...rest) => Logger.log(debugName, ...rest);
  L = Logger.log;
}

export const getCancelToken = () => {
  const { CancelToken } = axios;
  return CancelToken.source();
};

async function execRequest(config, requestId) {
  if (DEBUG) G(`-> make request (id: ${REQUEST_ID})`);
  if (DEBUG) L('type: FETCH');
  if (DEBUG) L('config:', config);
  if (DEBUG) GE(`-> make request (id: ${REQUEST_ID})`);
  try {
    const { data, headers, status } = await axios(config);
    if (DEBUG) G(`makeRequest success (id: ${requestId}, status: ${status})`);
    if (DEBUG) L('type: FETCH_COMPLETE');
    if (DEBUG) L('data:', data);
    if (DEBUG) L('status:', status);
    if (DEBUG) L('headers:', headers);
    if (DEBUG) GE(`makeRequest success (id: ${requestId}, status: ${status})`);
    return { data, status, headers };
  } catch (error) {
    if (DEBUG) G(`make request failed (id: ${requestId}, reason: ${error.message})`);

    if (axios.isCancel(error)) {
      if (DEBUG) L('type: FETCH_FAILED');
      if (DEBUG) L(`error: ${error}`);
      if (DEBUG) L('cancelled: true');
      if (DEBUG) GE(`make request failed (id: ${requestId}, reason: ${error.message})`);
      return { error, cancelled: true };
    }

    if (error.response) {
      const { data, status, headers } = error.response;
      if (DEBUG) L('type: FETCH_FAILED');
      if (DEBUG) L(`error: ${error}`);
      if (DEBUG) L('status:', status);
      if (DEBUG) L('headers:', headers);
      if (DEBUG) GE(`make request failed (id: ${requestId}, reason: ${error.message})`);
      return {
        error,
        data,
        status,
        headers,
      };
    }

    if (error.request) {
      const { request } = error;
      if (DEBUG) L('type: FETCH_FAILED');
      if (DEBUG) L(`error: ${error}`);
      if (DEBUG) L('request:', request);
      if (DEBUG) GE(`make request failed (id: ${requestId}, reason: ${error.message})`);
      return { error, request };
    }

    if (DEBUG) L('type: FETCH_FAILED');
    if (DEBUG) L(`error: ${error}`);
    if (DEBUG) GE(`make request failed (id: ${requestId}, reason: ${error.message})`);
    return { error };
  }
}

function makeApiRequest(requestConfig, session, { internal = true } = {}) {
  const { CancelToken } = axios;
  const config = typeof requestConfig === 'string' ? { url: requestConfig } : requestConfig;
  const source = CancelToken.source();

  if (!internal) {
    config.url = `${env.PUBLIC_INSTANT_MESSAGE_SERVICE_ENDPOINT}${config.url}`;
  }

  if (session && !session.expired) {
    config.headers = {
      Authorization: `${session.token_type} ${session.access_token}`,
    };
  }
  // eslint-disable-next-line no-plusplus
  if (DEBUG) REQUEST_ID++;
  return [
    execRequest({ cancelToken: source.token, ...config }, REQUEST_ID),
    () => {
      if (DEBUG) LN(`-> cancel request (id: ${REQUEST_ID})`);
      source.cancel();
    },
  ];
}

export default makeApiRequest;
